import { memo } from 'react'
import { useAgentStore } from '@/context/AgentProvider'
import { getChatState } from '@/state/useAgentStore'

const ComposerError = memo(() => {
  const chatKey = useAgentStore((s) => s.activeChatId ?? s.draftChatKey)
  const error = useAgentStore((s) => getChatState(s, chatKey).composerError)

  if (!error) return null

  return <div className='mp-agent-composer-error'>{error}</div>
})

ComposerError.displayName = 'ComposerError'

export default ComposerError
